import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsInformationBarrierEnabled = () => boolean;
export const useIsInformationBarrierEnabled: UseIsInformationBarrierEnabled = () =>
  useExperimentTreatmentWithoutReporting('InformationBarriersPhase0') === true;
